<template>
  <div id="crumbs" @mouseenter="openPresetMenu" @mouseleave="closePresetMenu">
    <button
      type="button"
      class="btn btn-ld"
      @mouseenter="openSubWSecond('ld')"
      @mouseleave="closeSubWSecond('ld')"
    >
      <!--      @click="openSubW('regular', 'ld')"-->

      <!--      :class="{-->
      <!--      'btn-ld-agent': auth.user.role === 7,-->
      <!--      'greyed-out':-->
      <!--      selectedMainTab !== 'clients' && greyOutTag('ld', selectedMainTab)-->
      <!--      }"-->
      <!--        {{ text }} <span>{{ kFormatter(stats) }}</span>-->
      <!--      {{ stats == 0 ? "LD" : kFormatter(stats) }}-->
      <!--      {{ statsOv > 0 && statsOv != 0 ? "/" + statsOv : "" }}-->
      <div
        v-tooltip="{
          placement: 'right',
          content:
            statsOv > 0 && stats > 0
              ? `
            ${getCR(statsOv, stats)}`
              : ''
        }"
      >
        <span v-if="kFormatter(statsOv) === 0 && kFormatter(stats) === 0">
          LD
        </span>
        <!--      <span v-else>{{ kFormatter(statsOv) + "/" + kFormatter(stats) }}</span>-->
        <span v-else>{{ kFormatter(stats) + "/" + kFormatter(statsOv) }}</span>
      </div>
      <div class="bb-sub-menu" v-if="checkSubMenuMode('ld')">
        <div
          class="bb-sub-menu-ms"
          @click.stop="openMsW('ld')"
          v-tooltip="{ content: `Open multi-select` }"
        >
          <div class="ld-color bb-item">
            <i class="fas fa-bars"></i>
          </div>
          <div class="fake-column ld-color"></div>
        </div>
        <div
          class="bb-sub-menu-reset"
          @click.stop="closeResetBtnW('ld')"
          v-tooltip="{ content: `Reset` }"
        >
          <div class="ld-color bb-item">
            <i class="fas fa-times"></i>
          </div>
          <div class="fake-column ld-color"></div>
        </div>
      </div>
      <div class="bb-sub-menu" v-if="checkIfSecondView('ld')">
        <div
          v-if="checkNumbersOfCalendarsSelected() === 1"
          class="bb-sub-menu-ms merged"
          @click.stop="mergeAllDates('ld', 'regular', shortCutsToBlocks)"
          v-tooltip="{
            content: `Use the same selected dates with this new selection`
          }"
        >
          <!--          @click.stop="filterMultipleTags('regular', 'ld')"-->

          <div class="ld-color bb-item">
            <div class="first-circle-tot"></div>
            <div class="second-circle-tot"></div>
            <div class="fake-column-tot ld-color"></div>
          </div>
        </div>
        <div
          class="bb-sub-menu-reset"
          @click.stop="filterSingleTag('regular', 'ld')"
          v-tooltip="{ content: `Disregard previous selections` }"
        >
          <div class="ld-color bb-item">
            <div class="first-circle first-circle-right"></div>
            <div class="second-circle second-circle-right"></div>
          </div>
          <div class="fake-column ld-color"></div>
        </div>
        <div
          class="bb-sub-menu-ms"
          @click.stop="filterMultipleTags('regular', 'ld')"
          v-tooltip="{ content: `Productivity` }"
        >
          <div class="ld-color bb-item">
            <div class="first-circle"></div>
            <div class="second-circle "></div>
            <div class="fake-column ld-color"></div>
          </div>
        </div>
      </div>
      <div class="bb-title-wrapper upper-title">
        <span class="leads">Lead</span>
      </div>
      <div
        class="tags-dropdown"
        v-if="
          openTagDropdown &&
            mouseOver &&
            !checkSubMenuMode('ld') &&
            !checkIfSecondView('ld')
        "
      >
        <!--        <div class="tags-dropdown" v-if="false">-->
        <TagsDropdown
          :btnColors="btnColors"
          @presetTrigger="emitPresetTrigger"
        />
      </div>
    </button>
  </div>
</template>

<script>
import breadButtonsFunctionsUtil from "../../mixins/breadButtonsFunctionsUtil";
import { mapState } from "vuex";
import calendarCheck from "../../../../../../mixins/tags/calendarCheck";
import TagsDropdown from "./TagsDropdown.component";
import { Globals } from "../../../../../../global_constants/constants";

export default {
  name: "BreadcrumbButton",
  components: {
    TagsDropdown
  },
  props: {
    ifCalendarSelected: {
      type: Object
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    secondActiveTagsArr: {
      type: Array
    },
    activeTags: {
      type: Array
    },
    extSearch: {
      type: Boolean
    },
    resetButtons: {
      type: Boolean
    },
    variant: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      required: true
    },
    txtColor: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    stats: {
      type: Number,
      required: false
    },
    statsOv: {
      type: Number,
      required: false
    },

    showOverall: {
      type: Boolean,
      required: false
    },
    switchPlaces: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      calendarForPreset: "LEAD_TAG",
      mouseOver: false,
      btnColors: {
        backgroundColor: "#4275ec",
        color: "white"
      },
      openTagDropdown: false,
      showPopup: false,
      resetBtn: {
        ld: false
      },
      totalSum: "",
      secondView: false
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "totalSumForCrumbBtn",
      "shortCutsToBlocks"
    ]),

    btnStyles() {
      return {
        "--bg-color": this.disabled ? "#546e7a" : this.bgColor,
        "--hover-on-disable": this.disabled ? "-3px" : "0px",
        "--font-weight": this.disabled ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    }
  },
  mixins: [breadButtonsFunctionsUtil, calendarCheck],

  methods: {
    closePresetMenu() {
      this.openTagDropdown = false;
      this.mouseOver = false;
    },
    openPresetMenu() {
      this.mouseOver = true;
      setTimeout(() => {
        if (this.mouseOver) {
          this.openTagDropdown = true;
        }
      }, Globals.ux.section.top_tag_menu.cal_presets_speed);
    },
    emitPresetTrigger(preset) {
      if (preset !== "ALL") {
        this.triggerPreset(this.calendarForPreset, preset);
      }
      if (preset) {
         this.openSubW("regular", "ld");
      }
    },
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      } else {
        return 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$btnColor: #4275ec;

$color: var(--bg-color);
$borderColor: var(--border-color);
$hoverColor: #546e7a;
$fontWeight: var(--font-weight);
.tag-wrapper {
  display: inline;
  position: relative;
}

#crumbs {
  position: relative;
  /*margin-right: 10px;*/
}

#crumbs a {
  display: block;
  float: left;
  height: 20px;
  width: 70px; //70px;
  line-height: 16pt;
  background: #4275ec;
  padding: 0 3px 0 4px;
  border-color: $borderColor;
  position: relative;
  margin: 0 20px 0 0;
  text-align: center;
  text-decoration: none;
  color: var(--txt-color);
  font-size: 12px; //9pt;
  font-family: "Montserrat" !important;
  font-weight: 500;
  /*$fontWeight;*/
  /*border-bottom-left-radius: 5px;*/
  /*border-bottom-right-radius: 5px;*/
  /*border-top-left-radius: 5px;*/
  top: var(--hover-on-disable);
}

#crumbs a:hover {
  top: -3px;
}

.tag-table {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}

.dot-right {
  height: 26px;
  width: 26px;
  color: #009147;
  /*border-radius: 50%;*/
  bottom: 11px;
  right: -7px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-left {
  height: 26px;
  width: 26px;
  background-color: $color;
  border-radius: 50%;
  bottom: 8px;
  left: -8px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.btn-ld {
  font-size: 10px;
  color: #ffffff;
  background-color: $btnColor;
  border-color: $btnColor;
  transition: all 0.2s ease-in;
  width: 100%;
  /*margin-right: 10px;*/
  border-radius: 5px !important;
}

.btn-ld {
  color: #ffffff;
  background-color: $btnColor;
  border-color: $btnColor;
  outline: none;
  font-weight: 900;
  /*max-width: 61px; */
  position: relative;
}

.btn-ld-agent {
  /*max-width: 80px;*/
}

.btn-ld:hover,
.btn-ld:focus,
.btn-ld:active,
.btn-ld.active .open .dropdown-toggle.btn-ld {
  color: #ffffff;
  background-color: $btnColor;
  border-color: $btnColor;
  outline: none;
  z-index: 0 !important;
}

.btn-ld:hover {
  outline: none;
  z-index: 1 !important;
  cursor: default;
}

.reset-btn {
  position: absolute;
  top: -8px;
  right: 0px;
  color: #333;
  transition: all 0.2s ease-in;
}

.reset-btn:hover {
  position: absolute;
  transform: scale(1.3);
  color: red;
}

.btn-ld:hover {
  transform: scale(1.1);
}

.btn-ld:hover div.bb-title-wrapper {
  /*left: 3px;*/
}

/*div.bb-title-wrapper{*/
/*  position: absolute;*/
/*  color: black;*/
/*  font-size: 8px;*/
/*  width: 85%;*/
/*  top: 28px;*/
/*  left: 0px;*/
/*  text-align: center;*/
/*  transition: left 0.2s;*/

/*}*/
div.bb-title-wrapper {
  //position: absolute;
  color: white;
  font-size: 8px;
  width: 85%;
  top: 28px;
  left: 0px;
  text-align: center;
  transition: width 0.2s ease-in;
}

.upper-title {
  text-transform: uppercase;
}

/*<!--.bb-sub-menu {-->*/
/*<!--  position: absolute;-->*/
/*<!--  width: 96%;-->*/
/*<!--  top: -24px;-->*/
/*<!--  left: 0px;-->*/
/*<!--  display: flex;-->*/
/*<!--  justify-content: space-between;-->*/
/*<!--}-->*/
/*<!--.bb-sub-menu-reset,-->*/
/*<!--.bb-sub-menu-ms {-->*/
/*<!--  padding: 3px 5px;-->*/
/*<!--  background-color: $btnColor;-->*/
/*<!--  border-radius: 4px;-->*/
/*<!--  height: 20px;-->*/
/*<!--  width: 20px;-->*/
/*<!--}-->*/
.bb-sub-menu-reset {
  /*margin-right: 10px;*/
}

.first-circle {
  background-color: white;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
}

.first-circle-tot {
  background-color: inherit;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
  border: 1px solid white;
}

.second-circle {
  background-color: white;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.second-circle-tot {
  border: 1px solid white;
  background-color: inherit;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.first-circle-right {
  /*left: 45px;*/
  background-color: white;
}

.second-circle-right {
  /*left: 50px;*/
  background-color: inherit;
  border: 1px solid white;
}

.greyed-out {
  opacity: 0.5;
  pointer-events: none;
}

.bb-sub-menu {
  position: absolute;
  width: 100%;
  top: -26px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  height: 30px;
  cursor: pointer;
}

.bb-sub-menu-reset,
.bb-sub-menu-ms {
  /*padding: 3px 5px;*/
  /*<!--background-color: $btnColor;-->*/
  border-radius: 4px;
  height: 30px;
  width: 20px;
}

.bb-item {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  padding-top: 3px;
  position: relative;
}

.fake-column {
  width: 8px;
  height: 10px;
  /*height: 23px;*/
  margin-left: 6px;
}

.fake-column-tot {
  width: 8px;
  /*height: 10px;*/
  height: 23px;
  margin-left: 6px;
}

div.second-circle + div.fake-column {
  margin-top: 14px;
}

.ld-color {
  background-color: $btnColor;
}

.btn-group {
  z-index: 0 !important;
}

.tags-dropdown {
  /*padding: 3px 5px;*/
  position: absolute;
  /*background-color: wheat;*/
  top: 38px;
  left: 0px;
  z-index: 1;
  border-radius: 5px;
  width: 100%;
}

.leads {
  padding-left: 5px;
}
</style>
